import { Accordion, Paper } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { DateRangePicker } from "@mantine/dates";
import { BsCalendar2Date } from "react-icons/bs";
import { useQueryParam } from "use-query-params";
import { MdDateRange } from "react-icons/md";
import dayjs from "dayjs";
import AccordionFilterLabel from "../filter-components/AccordionFilterLabel";

const CustomDateParam = {
  encode: (array) => {
    if (!array[0] && !array[1]) {
      return undefined;
    }
    return array.map((date) => dayjs(date).format("YYYY-MM-DD")).join("|");
  },
  decode: (arrayStr) => {
    return arrayStr?.split("|");
  },
};

const DateRangeFilter = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [date, setDate] = useQueryParam("date", CustomDateParam);

  return (
    <Paper
      shadow={!isMobile ? "sm" : ""}
      p={isMobile ? 0 : "xs"}
      mb={!isMobile ? 15 : ""}
      withBorder
    >
      <Accordion
        defaultValue="Wanneer wilt u weg?"
        variant="filled"
        styles={{ panel: { background: "white" } }}
      >
        <Accordion.Item value="Wanneer wilt u weg?">
          <Accordion.Control>
            <AccordionFilterLabel
              label={"Check In - Out"}
              icon={BsCalendar2Date}
              color="violet"
            />
          </Accordion.Control>
          <Accordion.Panel>
            <DateRangePicker
              zIndex={2147483002}
              placeholder="Wanneer wilt u weg?"
              variant="default"
              size="md"
              amountOfMonths={isMobile ? 1 : 2}
              locale="nl"
              inputFormat={"DD MMM. YYYY"}
              icon={<MdDateRange style={{ color: "#297CBB" }} />}
              value={date?.map((d) => new Date(d))}
              minDate={new Date()}
              onChange={(date) => {
                if (!date[0] && !date[1]) {
                  setDate([null, null]);
                }

                if (date[0] && date[1]) {
                  setDate(date);
                }
              }}
              styles={{ icon: { bottom: 4 } }}
              clearable
            />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Paper>
  );
};

export default DateRangeFilter;
